import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { TILE_URL } from "../config";

import iconUrl from "../assets/marker-icon.png";
import shadowUrl from "../assets/marker-shadow.png";

const markerIcon = new L.Icon({
  iconUrl: iconUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: shadowUrl,
  shadowSize: [41, 41],
});

const defaultPosition = [25.23293, 55.30577];

function InvalidateMapSize({ forceRefresh }) {
  const map = useMap();
  useEffect(() => {
    map.invalidateSize();
  }, [forceRefresh, map]);
  return null;
}

function CenterMapOnMarker({ position }) {
  const map = useMap();
  useEffect(() => {
    if (map && Array.isArray(position) && position.length === 2) {
      map.setView(position, map.getZoom());
    }
  }, [position, map]);
  return null;
}

function LocationPicker({ value, onChange, disabled = false, setContainerMap, forceRefresh }) {
  function MapClicker() {
    useMapEvents({
      click(e) {
        if (!disabled) onChange([e.latlng.lat, e.latlng.lng]);
      },
    });
    return null;
  }

  return (
    <MapContainer
      center={value || defaultPosition}
      zoom={13}
      minZoom={12}
      maxZoom={19}
      style={{
        height: "100%",
        width: "100%",
        borderRadius: 4,
        opacity: disabled ? 0.7 : 1,
      }}
      scrollWheelZoom={true}
      attributionControl={false}
      whenCreated={setContainerMap}
    >
      <InvalidateMapSize forceRefresh={forceRefresh} />
      <CenterMapOnMarker position={value || defaultPosition} />
      <TileLayer
        url={TILE_URL}
        attribution="&copy; OpenStreetMap contributors"
        maxNativeZoom={19}
        maxZoom={19}
      />
      {value && (
        <Marker
          position={value}
          icon={markerIcon}
          draggable={!disabled}
          eventHandlers={!disabled ? {
            dragend: (e) => {
              const { lat, lng } = e.target.getLatLng();
              onChange([lat, lng]);
            },
          } : {}}
        />
      )}
      <MapClicker />
    </MapContainer>
  );
}

export default LocationPicker;